const emojis = null;
const getEmoji = null;

export default { emojis, getEmoji };
